module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome allfrmptags"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1), _c('div', {
    staticClass: "left"
  }), _c('div', {
    staticClass: "main-form"
  }, [_c('div', {
    staticClass: "innerapp"
  }, [_c('form', {
    attrs: {
      "action": "https://beaumontortho.com/email/",
      "method": "post"
    }
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfwfFwUAAAAAAUsIWtZ8aO3BS4O8lHPBoIwF7oi",
      "badge": "inline"
    }
  })], 1)]), _vm._m(3)])])])])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Name")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "yourName",
      "id": "yourName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Email ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "EmailId",
      "id": "EmailId"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Feedback ")]), _c('textarea', {
    attrs: {
      "name": "yourFeedback",
      "id": "yourFeedback"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt buttonallrt"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "Feedback"
    }
  }), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit Feedback",
      "onclick": "return validateFeedback()"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d231ce","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/feedback/feedback.pug
// module id = 591
// module chunks = 1